const facebookSourceType = {
  fbPersonal: {
    id: 1,
    type: 'fbPersonal',
    description: 'User\'s facebook business ad Account',
  },
  fbLiondesk: {
    id: 2,
    type: 'fbLiondesk',
    description: 'LionDesk facebook ads',
  },
};

export default facebookSourceType;
